const initialState = {
  pageTabState: {
    page1:{
    activeTab: 1,
    }
  }
};
const wrapperTabsReducer = (state = initialState, action: any = {} ) => {
  switch (action.type) {
    case "tabClicked":
      return {
        ...state,
          pageTabState:{
            ...state.pageTabState,
            [`page${action.pageTabState.pageNumber}`]: {
             activeTab: action.pageTabState.activeTab,
          }
        }
      };

    default:
      return state;
  }
};

export default wrapperTabsReducer;